import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Layout, NavDrawer, Panel, Sidebar } from 'react-toolbox/lib/layout'
import { Route, Switch } from 'react-router-dom'

import CSSModules from 'helpers/CSSModulesUtil'
import injectSagas from 'helpers/injectSagas'
import NavDrawerContent from 'containers/Approval/NavDrawer/index'
import SideNavBar from './SideNavBar'
import MainPanel from './MainPanel'
import ApprovalPageBody from 'containers/Approval/MainPanel/index'
import ApprovalDialog from 'containers/Approval/ApprovalDialog/index'

import theme from './ApprovalPage.scss'

import {
  MODULE_NAME,
} from './constants'
import {
  fetchApprovals,
  approvalPageMount,
  approvalPageUnmount,
} from './actions'
import {
  approvalsSelector,
  currentApprovalSelector,
} from './selectors'

const mapStateToProps = (state) => {
  return {
    currentApproval: currentApprovalSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadApprovals: () => dispatch(fetchApprovals()),
    onMount: () => dispatch(approvalPageMount()),
    onUnmount: () => dispatch(approvalPageUnmount()),
  }
}

class ApprovalPage extends Component {
  componentWillMount() {
    this.props.onMount()
  }

  componentWillUnmount() {
    this.props.onUnmount()
  }

  render() {
    return (
      <Layout theme={theme}>
        <NavDrawer theme={theme} pinned scrollY >
          <NavDrawerContent/>
        </NavDrawer>
        <Panel theme={theme}>
          <Switch>
            <Route exact path='/project/approvals/:id' component={ApprovalPageBody}/>
          </Switch>
        </Panel>
        <Sidebar theme={theme} pinned >
          <SideNavBar currentApproval={this.props.currentApproval}/>
        </Sidebar>
        <ApprovalDialog/>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(theme)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(ApprovalPage)
